export default "/images/4f0fd437e9185c742f05b8c68235fe62.avif";